const SELECTORS = {
  mainContent: '#MainContent',
  announcement: '.shopify-section-group-header-group .announcement-bar',
  header: '.shopify-section-group-header-group #SiteHeader',
  stickyHeaderWrap: '#StickyHeaderWrap',
};

const STUCK_CLASS = 'site-header--stuck';
const SCROLL_THROTTLE_MS = 20;

function measureHeaderHeight() {
  const announcementBar = document.querySelector(SELECTORS.announcement);
  const header = document.querySelector(SELECTORS.header);
  const stickyHeaderWrap = document.querySelector(SELECTORS.stickyHeaderWrap);

  if (header?.classList.contains(STUCK_CLASS) && stickyHeaderWrap) {
    return stickyHeaderWrap.offsetHeight;
  }

  const announcementBarHeight = announcementBar?.offsetHeight || 0;
  const headerHeight = header?.offsetHeight || 0;

  return announcementBarHeight + headerHeight;
}

function updateHeaderHeight() {
  const mainContent = document.querySelector(SELECTORS.mainContent);
  const height = measureHeaderHeight();

  mainContent?.style.setProperty('--header-height', `${height}px`);
}

function initHeaderObserver() {
  const header = document.querySelector(SELECTORS.header);

  if (!header) {
    return;
  }

  const observer = new MutationObserver(updateHeaderHeight);
  observer.observe(header, { attributes: true, attributeFilter: ['class'] });
}

let scrollTimer = null;
function handleScroll() {
  if (scrollTimer !== null) {
    return;
  }

  scrollTimer = window.setTimeout(() => {
    scrollTimer = null;
    updateHeaderHeight();
  }, SCROLL_THROTTLE_MS);
}

function init() {
  updateHeaderHeight();
  initHeaderObserver();
  window.addEventListener('scroll', handleScroll, { passive: true });
}

window.addEventListener('load', updateHeaderHeight);

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(updateHeaderHeight, 100);
});

document.addEventListener('shopify:section:load', updateHeaderHeight);
document.addEventListener('shopify:section:reorder', updateHeaderHeight);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
